<template>
  <div class="timeline-notes">
    <section v-for="(group, index) in groups" :key="index" class="timeline-evolution">
      <h3>{{ group.label || 'Évolution non libellée' }}</h3>
      <p v-if="group.date" class="timeline-note-meta"><time :datetime="group.date">{{ date(group.date) }}</time></p>
      <article v-for="(entry, position) in group.entries" :key="String(entry.historique_id) + '-' + position" class="timeline-note">
        <p class="timeline-note-meta"><time v-if="entry.date" :datetime="entry.date">{{ date(entry.date) }}</time><span v-else>Date non renseignée</span> · {{ entry.author || 'Auteur non renseigné' }}</p>
        <p v-if="entry.readable === false" role="status">Le contenu de cette note ancienne n’a pas pu être lu.</p>
        <div v-else class="timeline-note-content" v-html="render(entry)"></div>
      </article>
      <p v-if="!group.entries.length">Aucune observation enregistrée pour cette évolution.</p>
    </section>
    <p v-if="!groups.length">Aucune observation enregistrée pour cette consultation.</p>
    <section
            v-if="detail.corrections_issue && detail.corrections_issue.length"
            aria-label="Corrections de l’issue"
        >
            <h3>Corrections de l’issue</h3>
            <article
                v-for="(correction, index) in detail.corrections_issue"
                :key="index"
                class="timeline-note"
            >
                <p class="timeline-note-meta">
                    <time :datetime="correction.date">{{ date(correction.date) }}</time>
                    · {{ correction.medecin }}
                </p>
                <p>{{ issue(correction.ancienne_issue) }} → {{ issue(correction.nouvelle_issue) }}</p>
                <p>{{ evolution(correction.ancienne_evolution) }} → {{ evolution(correction.nouvelle_evolution) }}</p>
                <p>Motif : {{ correction.motif }}</p>
            </article>
        </section>
  </div>
</template>
<script>
import { historique_lecture } from '@/utils/resume-consultation-print'
import { timelineDate } from '@/utils/patient-consultation-timeline'
import { issueLabel, evolutionLabel } from '@/utils/consultation-issues'
export default {
  name: 'TimelineClinicalNotes',
  props: { detail: { type: Object, required: true }, timezone: { type: String, default: '' } },
  computed: {
    groups() {
      const groups = (this.detail.evolutions || []).map(group => ({ ...group, entries: group.entries || [] }))
      const ids = new Set(groups.reduce((all, group) => all.concat(group.entries.map(entry => String(entry.historique_id))), []))
      const rest = (this.detail.historiques || []).filter(entry => !ids.has(String(entry.historique_id)))
      if (rest.length) groups.push({ label: 'Autres notes enregistrées', entries: rest })
      return groups
    }
  },
  methods: { issue: issueLabel, evolution: evolutionLabel, date(value) { return timelineDate(value, this.timezone) }, render(entry) { return historique_lecture({ ...entry, user: entry.author }) } }
}
</script>
<style scoped lang="scss">
.timeline-notes { color: var(--ui-text, #172033); overflow-wrap: anywhere; }
.timeline-evolution + .timeline-evolution { margin-top: 22px; padding-top: 18px; border-top: 1px solid #d4dfef; }
h3 { font-size: 17px; font-weight: 700; margin: 0 0 8px; }
.timeline-note { padding: 12px 0; } .timeline-note + .timeline-note { border-top: 1px solid #e3eaf4; }
.timeline-note-meta { font-size: 13px; color: var(--ui-text-muted, #526074); margin: 0 0 6px; }
.timeline-note-content { overflow-x: auto; }
.timeline-note-content ::v-deep h2 { font-size: 15px; font-weight: 700; color: var(--ui-text, #172033); }
.timeline-note-content ::v-deep table { width: 100%; border-collapse: collapse; }
.timeline-note-content ::v-deep th, .timeline-note-content ::v-deep td { border: 1px solid #d4dfef; padding: 6px; color: var(--ui-text-secondary, #273449); }
.timeline-note-content ::v-deep summary { cursor: pointer; color: var(--ui-accent, #2457c5); }
</style>
